module.exports = __webpack_public_path__ + "static/media/login-background.c538d1a5.jpg";